<template>
  <div class="pro-form-ins">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="pro-form-ins-cfg">
        <!-- <b>
          Qual é a caracteristica deste produto?
        </b> -->

        <div class="campos">
          <App-Select :data-time="time" class="pro-form-det--produto_acabado"
          :cpntStatus='campos.produto_acabado.status'
          :cpntId='campos.produto_acabado.id'
          :cpntTabIndex='campos.produto_acabado.tabIndex'
          :cpntNome='campos.produto_acabado.nome'
          :cpntValue='campos.produto_acabado.value'
          :cpntMensagem='campos.produto_acabado.mensagem'
          :cpntMensagemTipo='campos.produto_acabado.mensagemTipo'
          :cpntDisabled='campos.produto_acabado.disabled'
          :cpntMostrar='campos.produto_acabado.mostrar'
          :cpntExplica='campos.produto_acabado.explica'
          :cpntPlaceholder='campos.produto_acabado.placeholder'
          :cpntValueRef='campos.produto_acabado.valueRef'
          :cpntRouter='campos.produto_acabado.router'
          :cpntMethod='campos.produto_acabado.method'
          :cpntField='campos.produto_acabado.field'
          :cpntWhere='campos.produto_acabado.where'
          :cpntAddButForm='campos.produto_acabado.addButForm'
          :cpntKeyMostra='campos.produto_acabado.keyMostra'
          :cpntTipoOrder='campos.produto_acabado.tipoOrder'
          :cpntOrder='campos.produto_acabado.order'
          :cpntOptions='campos.produto_acabado.options'
          :cpntKeyValue='campos.produto_acabado.keyValue'
          :cpntSearchMinimo='campos.produto_acabado.searchMinimo'
          :cpntMask='campos.produto_acabado.mask'
          :cpntOptionInicialNome='campos.produto_acabado.optionInicialNome'
          :cpntOptionInicialValue='campos.produto_acabado.optionInicialValue'

          :cpntOnBuscarOptions='campos.produto_acabado.onBuscarOptions'
          :cpntOnChange='campos.produto_acabado.onChange'
          :cpntOnBlur='campos.produto_acabado.onBlur'
          :cpntOnRealizaBusca='campos.produto_acabado.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.produto_acabado.onKeyPressEnter'
          ref="produto_acabado"
          ></App-Select>

          <App-Select :data-time="time" class="pro-form-det--insumo"
          :cpntStatus='campos.insumo.status'
          :cpntId='campos.insumo.id'
          :cpntTabIndex='campos.insumo.tabIndex'
          :cpntNome='campos.insumo.nome'
          :cpntValue='campos.insumo.value'
          :cpntMensagem='campos.insumo.mensagem'
          :cpntMensagemTipo='campos.insumo.mensagemTipo'
          :cpntDisabled='campos.insumo.disabled'
          :cpntMostrar='campos.insumo.mostrar'
          :cpntExplica='campos.insumo.explica'
          :cpntPlaceholder='campos.insumo.placeholder'
          :cpntValueRef='campos.insumo.valueRef'
          :cpntRouter='campos.insumo.router'
          :cpntMethod='campos.insumo.method'
          :cpntField='campos.insumo.field'
          :cpntWhere='campos.insumo.where'
          :cpntAddButForm='campos.insumo.addButForm'
          :cpntKeyMostra='campos.insumo.keyMostra'
          :cpntTipoOrder='campos.insumo.tipoOrder'
          :cpntOrder='campos.insumo.order'
          :cpntOptions='campos.insumo.options'
          :cpntKeyValue='campos.insumo.keyValue'
          :cpntSearchMinimo='campos.insumo.searchMinimo'
          :cpntMask='campos.insumo.mask'
          :cpntOptionInicialNome='campos.insumo.optionInicialNome'
          :cpntOptionInicialValue='campos.insumo.optionInicialValue'

          :cpntOnBuscarOptions='campos.insumo.onBuscarOptions'
          :cpntOnChange='campos.insumo.onChange'
          :cpntOnBlur='campos.insumo.onBlur'
          :cpntOnRealizaBusca='campos.insumo.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.insumo.onKeyPressEnter'
          ref="insumo"
          ></App-Select>
        </div>
      </div>

      <div class="cabecalho">
        <div class="botao">
          <App-Button :data-time="time" v-if="cpntEditarVarios === false"
            :cpntId='botao.id'
            :cpntStatus='botao.status' 
            :cpntIcone='botao.icone'
            :cpntTexto='botao.texto'
            :cpntClass='botao.class'
            :cpntDisabled="botao.disabled"
            @onClick='botao.onClick'
          ></App-Button>
        </div>

        <div class="config">
          <App-Toggles :data-time="time" style="max-width: 190px;"
            :cpntStatus='campos.ins_fab_aut_na_venda.status'
            :cpntId='campos.ins_fab_aut_na_venda.id'
            :cpntClassDivField='campos.ins_fab_aut_na_venda.classDivField'
            :cpntNome='campos.ins_fab_aut_na_venda.nome'
            :cpntValue='campos.ins_fab_aut_na_venda.value'
            :cpntMostrar='campos.ins_fab_aut_na_venda.mostrar'
            :cpntMensagem='campos.ins_fab_aut_na_venda.mensagem'
            :cpntMensagemTipo='campos.ins_fab_aut_na_venda.mensagemTipo'
            :cpntOn='campos.ins_fab_aut_na_venda.on'
            :cpntOff='campos.ins_fab_aut_na_venda.off'
            :cpntExplica='campos.ins_fab_aut_na_venda.explica'
            :cpntWidth='campos.ins_fab_aut_na_venda.width'
            :cpntTabIndex='campos.ins_fab_aut_na_venda.tabIndex'
            :cpntDisabled='campos.ins_fab_aut_na_venda.disabled'
            :cpntOnChange='campos.ins_fab_aut_na_venda.onChange'
            :cpntOnBlur='campos.ins_fab_aut_na_venda.onBlur'
            ref='ins_fab_aut_na_venda'
          ></App-Toggles>
        </div>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela v-if="cpntEditarVarios === false"
        :cpntMontarWhere="proFormInsumoTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntSetarValores="proFormInsumoSetarLinhas"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiMethods="'GET'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='proFormInsumoMarcarCheckbox'
        ref="tabela">
          <!-- SETA A COLUNA QUANTIDADE -->
          <template v-slot:col_qtde="{ linha, indexL }">
            <App-Input :data-time="time" class="pro-form-ins--qtde"
              :cpntStatus='campos.qtde.status'
              :cpntId='campos.qtde.id'
              :cpntTabIndex='campos.qtde.tabIndex'
              :cpntClassDivField='campos.qtde.classDivField'
              :cpntNome='campos.qtde.nome'
              :cpntValue='linha.qtde'
              :cpntAutoComplete='campos.qtde.autocomplete'
              :cpntMask='campos.qtde.mask'
              :cpntOptionInicialNome='campos.qtde.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde.optionInicialValue'
              :cpntDisabled='campos.qtde.disabled'
              :cpntMostrar='campos.qtde.mostrar'
              :cpntExplica='campos.qtde.explica'
              :cpntAutoFocus='campos.qtde.autofocus'
              :cpntMensagem='campos.qtde.mensagem'
              :cpntMensagemTipo='campos.qtde.mensagemTipo'
              :cpntPlaceholder='campos.qtde.placeholder'
              :cpntPosicionar='campos.qtde.posicionar'
              :cpntOnChange='(value) => { proFormInsumoOnChangeValue(indexL, "qtde", value) }'
            ></App-Input>
          </template>

          <!-- SETA A COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-if="[ '', null, undefined ].indexOf(linha.last_at_ptbr) === -1" v-html="linha.last_user_usuario + '<br/>' + linha.last_at_ptbr"></span>
          </template>
        </App-Tabela>
      </div>

      <!-- SETA O FORMULARIO PARA INSERIR UM NOVO INSUMO -->
      <RF-Dialog v-if="formulario === true"
      :cpntLargura='"600px"'
      :cpntStatus="''"
      :cpntOnFecharDialog="proFormInsumoOnFecharFormulario">
      <template slot='titulo'>
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        <b>Inserir insumo no produto</b>
      </template>

      <template slot='conteudo'>
        <div class="pro-form-ins-inserir" :data-time="time" :class="[ '', null, undefined ].indexOf(campos.produto.value) === -1 && [ '', null, undefined ].indexOf(campos.produto.value.id) === -1 ? 'completo' : 'resumido'">
          <div>
            <App-Autocompletar :data-time="time" class="pro-form-ins-inserir--produto"
              :cpntStatus='campos.produto.status'
              :cpntId='campos.produto.id'
              :cpntTabIndex='campos.produto.tabIndex'
              :cpntNome='campos.produto.nome'
              :cpntValue='campos.produto.value'
              :cpntMensagem='campos.produto.mensagem'
              :cpntMensagemTipo='campos.produto.mensagemTipo'
              :cpntDisabled='campos.produto.disabled'
              :cpntMostrar='campos.produto.mostrar'
              :cpntExplica='campos.produto.explica'
              :cpntPlaceholder='campos.produto.placeholder'
              :cpntValueRef='campos.produto.valueRef'
              :cpntRouter='campos.produto.router'
              :cpntMethod='campos.produto.method'
              :cpntField='campos.produto.field'
              :cpntFieldVirtual='campos.produto.fieldVirtual'
              :cpntWhere='campos.produto.where'
              :cpntAddButForm='campos.produto.addButForm'
              :cpntKeyMostra='campos.produto.keyMostra'
              :cpntTipoOrder='campos.produto.tipoOrder'
              :cpntOrder='campos.produto.order'
              :cpntOptions='campos.produto.options'
              :cpntKeyValue='campos.produto.keyValue'
              :cpntSearchMinimo='campos.produto.searchMinimo'
              :cpntMask='campos.produto.mask'
              :cpntNewOption='campos.produto.newOption'

              :cpntOnChange='campos.produto.onChange'
              :cpntOnBlur='campos.produto.onBlur'
              :cpntOnRealizaBusca='campos.produto.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.produto.onKeyPressEnter'
              ref="produto"
            ></App-Autocompletar>

            <App-Input :data-time="time" class="pro-form-ins-inserir--qtde"
              :cpntStatus='campos.qtde.status'
              :cpntId='campos.qtde.id'
              :cpntTabIndex='campos.qtde.tabIndex'
              :cpntNome='campos.qtde.nome'
              :cpntValue='campos.qtde.value'
              :cpntMensagem='campos.qtde.mensagem'
              :cpntMensagemTipo='campos.qtde.mensagemTipo'
              :cpntDisabled='campos.qtde.disabled'
              :cpntMostrar='campos.qtde.mostrar'
              :cpntExplica='campos.qtde.explica'
              :cpntPlaceholder='campos.qtde.placeholder'
              :cpntValueRef='campos.qtde.valueRef'
              :cpntRouter='campos.qtde.router'
              :cpntField='campos.qtde.field'
              :cpntWhere='campos.qtde.where'
              :cpntAddButForm='campos.qtde.addButForm'
              :cpntKeyMostra='campos.qtde.keyMostra'
              :cpntTipoOrder='campos.qtde.tipoOrder'
              :cpntOrder='campos.qtde.order'
              :cpntOptions='campos.qtde.options'
              :cpntKeyValue='campos.qtde.keyValue'
              :cpntSearchMinimo='campos.qtde.searchMinimo'
              :cpntMask='campos.qtde.mask'

              :cpntOnChange='campos.qtde.onChange'
              :cpntOnBlur='campos.qtde.onBlur'
              :cpntOnRealizaBusca='campos.qtde.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.qtde.onKeyPressEnter'
              ref="qtde"
            ></App-Input>
          </div>

          <div class="botoes">
            <App-Button :data-time='time'
              :cpntStatus='botoes.salvar.status' 
              :cpntId='botoes.salvar.id' 
              :cpntTexto='botoes.salvar.texto' 
              :cpntClass='botoes.salvar.class'
              :cpntTabIndex='botoes.salvar.tabIndex'
              @onClick='botoes.salvar.onClick'
            ></App-Button>

            <App-Button :data-time='time'
              :cpntStatus='botoes.cancelar.status' 
              :cpntId='botoes.cancelar.id' 
              :cpntTexto='botoes.cancelar.texto' 
              :cpntClass='botoes.cancelar.class'
              :cpntTabIndex='botoes.cancelar.tabIndex'
              @onClick='botoes.cancelar.onClick'
            ></App-Button>
          </div>
        </div>
      </template>
      </RF-Dialog>
    </template>
  </div>
</template>

<style scoped>
  .pro-form-ins-cfg {
    width: 100%;
    margin: 0px auto;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background: #e9e9e9;
    text-align: center;
  }
    .pro-form-ins-cfg > .campos {
      width: 300px;
      margin: 0px auto;
      padding-bottom: 5px;
    }
    .pro-form-ins-cfg > b {
      display: block;
    }
    .pro-form-ins-cfg > .campos > div.cpnt-app-select {
      margin-top: 15px;
      width: calc((100% / 2) - 5px);
      margin-bottom: 0px !important;
    }
    .pro-form-ins-cfg > .campos > div.cpnt-app-select:last-child {
      margin-left: 10px;
    }

  .pro-form-ins > .cabecalho {
    margin-top: 30px;
  }
  .pro-form-ins > .cabecalho > .botao {
    margin-bottom: 2px;
    width: calc(100% - 220px);
    display: inline-block;
  }
  .pro-form-ins > .cabecalho > .config {
    display: inline-block;
    width: 220px;
    text-align: right;
    vertical-align: top;
  }
    .pro-form-ins > .cabecalho > .config > .cpnt-app-toggle {
      width: 100%;
      margin: 0px auto;
    }

  .pro-form-ins-inserir {
    width: 350px;
    margin: 0px auto;

    padding: 22px 12px 13px 12px;
    background: #efefef;
    border: 1px solid #c6c4c4;
    border-radius: 5px;
  }
  .pro-form-ins-inserir.completo {
    width: 100%;
  }
    .pro-form-ins-inserir.completo > div > .pro-form-ins-inserir--produto {
      width: calc(100% - 160px);
    }
    .pro-form-ins-inserir > div > .pro-form-ins-inserir--qtde {
      display: none;
    }
    .pro-form-ins-inserir.completo > div > .pro-form-ins-inserir--qtde {
      width: 150px;
      margin-left: 10px;
      display: inline-block;
    }

    .pro-form-ins-inserir > .botoes {
      display: none;
    }
    .pro-form-ins-inserir.completo > .botoes {
      display: block;
      width: calc(100%);
      margin-top: 10px;
      text-align: center;
    }
      .pro-form-ins-inserir.completo > .botoes > button {
        margin: 0px 5px;
      }
</style>

<style>
  .pro-form-ins > .tabela > table > tbody > tr > td.col_last {
    width: 120px;
  }
  .pro-form-ins > .tabela > table > tbody > tr > td.col_qtde {
    width: 140px;
  }
    .pro-form-ins > .tabela > table > tbody > tr > td.col_qtde > div > span > div > input {
      text-align: center;
    }

  .pro-form-ins > .cabecalho > .config > .cpnt-app-toggle > div {
    width: 100% !important;
  }
  .pro-form-ins-cfg > .campos > div.cpnt-app-select > label {
    width: 100%;
    text-align: center;
  }
    .pro-form-ins-cfg > .campos > div.cpnt-app-select > div > a {
      text-align: center !important;
    }
    .pro-form-ins-cfg > .campos > div.cpnt-app-select > div > a {
      padding-left: 0px;
    }
      .pro-form-ins-cfg > .campos > div.cpnt-app-select > div > a > .select2-chosen {
        width: 100%;
      }
</style>

<script>
  export default {
    props: {
      cpntHashId: {
        required: true
      },
      cpntId: {
        required: true
      },
      cpntDados: {
        required: true
      },
      cpntEditarVarios: {
        required: true
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        formData: null,
        checkbox: [],
        route: '/produto/insumo/get/',
        botao: {
          status: '',
          texto: 'Adicionar Insumo',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => { this.proFormInsumoOnFecharFormulario() }
        },
        colunas: [],
        linha: [],
        where: {},
        estruturaQueryGet: [
          [ 'SemPaginacao', 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoExcluir: undefined,
        formulario: false,
        campos: {
          produto_acabado: {
            id: this.cpntHashId + '--produto_acabado',
            status: '',
            nome: 'Produto acabado',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [
              { id: 's', nome: 'Sim' },
              { id: 'n', nome: 'Não' }
            ],
            value: '',
            valueIni: '',
            optionInicialNome: '',
            apiEnv: 'produto_acabado',
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.campos.produto_acabado.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          },
          insumo: {
            id: this.cpntHashId + '--insumo',
            status: '',
            nome: 'Insumo',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [
              { id: 's', nome: 'Sim' },
              { id: 'n', nome: 'Não' }
            ],
            value: '',
            valueIni: '',
            optionInicialNome: '',
            apiEnv: 'insumo',
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.campos.insumo.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          },
          ins_fab_aut_na_venda: {
            id: this.cpntHashId + '--ins_fab_aut_na_venda',
            status: '',
            nome: 'Fabricação automática na Venda?',
            value: false,
            apiEnv: 'ins_fab_aut_na_venda',
            explica: { mensagem: 'colocar aqui um explicação', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.campos.ins_fab_aut_na_venda.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          },
          produto: {
            status: '',
            tabIndex: 6004051,
            nome: 'Produto (DIGITE e SELECIONE)',
            router: '/produto/get',
            method: 'POST',
            field: { codigo: null, id: null, nome: null, id_uni: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } } },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' }, { f: 'insumo', o: '=', v: 's' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar novo produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.proFormInsumoOnNovoProduto
            },
            value: '',
            valueRef: '',
            mostrar: true,
            onRealizaBusca: () => {
              // LIMPA O CAMPO, PARA FECHAR OS FORMULARIOS
              this.campos.produto.value = ''
              this.campos.produto.valueRef = ''

              // SETA OS VALORES INICIAIS
              this.campos.qtde.value = '1,00'

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            },
            onChange: (value) => { this.proFormInsumoOnChangeValueForm('produto', value) }
          },
          qtde: {
            status: '',
            tabIndex: 6004052,
            nome: '',
            value: '',
            valueRef: '',
            mostrar: true,
            mask: 'VALOR_DECIMAL_CAMPO',
            onChange: (value) => { this.proFormInsumoOnChangeValueForm('qtde', value) },
            onKeyPressEnter: this.proFormInsumoInserirProduto
          },
          j_insumo: {
            status: '',
            nome: '',
            value: '',
            apiEnv: 'j_insumo',
            valueRef: '',
            onKeyPressEnter: this.proFormInsumoInserirProduto
          }
        },
        botoes: {
          salvar: {
            status: '',
            tabIndex: 6004081,
            texto: 'Inserir produto',
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.proFormInsumoInserirProduto() }
          },
          cancelar: {
            status: '',
            tabIndex: 6004082,
            texto: 'Cancelar',
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            mostrar: true,
            onClick: () => {
              // LIMPA O VALOR SELECIONADO
              this.proFormInsumoOnChangeValueForm('produto', '')

              // SETA O FOCUS NO CAMPO
              this.proFormInsumoRealizarFocusCampo('produto')
            }
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.proFormInsumoSetarStatusGeral('carregando')

      // VERIFICA SE ESTÁ EDITANDO OU INSERIDO UM NOVO REGISTRO
      if (typeof this.cpntId !== 'object' && this.cpntId >= 1) {    
        // VERIFICA SE O PRODUTO TEM A AUTO FABRICAÇÃO ATIVADA
        this.campos.ins_fab_aut_na_venda.value = this.cpntDados.ins_fab_aut_na_venda === 's'

        // VERIFICA SE O PRODUTO É UM PRODUTO ACABADO
        this.campos.produto_acabado.value = this.cpntDados.produto_acabado === 's' ? { id: 's', nome: 'Sim' } : { id: 'n', nome: 'Não' }

        // VERIFICA SE O PRODUTO É INSUMO
        this.campos.insumo.value = this.cpntDados.insumo === 's' ? { id: 's', nome: 'Sim' } : { id: 'n', nome: 'Não' }
      } else if (this.cpntId === 0) {
        // VERIFICA SE O PRODUTO TEM A AUTO FABRICAÇÃO ATIVADA
        this.campos.ins_fab_aut_na_venda.value = this.$store.state.configuracoes.produto.ins.cfg_ins_fab_aut_na_venda === true

        // VERIFICA SE O PRODUTO É UM PRODUTO ACABADO
        this.campos.produto_acabado.value = [ 'insumo_form', 'insumo_gere' ].indexOf(this.$route.name) === -1 ? { id: 's', nome: 'Sim' } : { id: 'n', nome: 'Não' }

        // VERIFICA SE O PRODUTO É INSUMO
        this.campos.insumo.value = [ 'insumo_form', 'insumo_gere' ].indexOf(this.$route.name) !== -1 ? { id: 's', nome: 'Sim' } : { id: 'n', nome: 'Não' }
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
      
      // INICIA O CARREGAMENTO DA TELA
      this.proFormInsumoBuscarLinhas(this.cpntId)
    },
    methods: {
      proFormInsumoBuscarLinhas: function (id) {
        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoExcluir = this.proFormInsumoExcluir

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id_pro', o: '=', v: id } ] }

        // FAZ O PROCESSO PARA NÃO BUSCAR NENHUM REGISTRO NA TABELA
        if (this.cpntEditarVarios === true) {
          this.where.aAnd.push({ f: 'id_pro', o: '=', v: '-1' })
        }

        // SETA A ORDENAÇÃO DA TABELA
        this.order = { id_pro_insumo_nome: 'asc', id: 'asc' }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,  chave: 'id',                                              fieldsApi: {}, tipo: 'checkbox' },
          { mPer: 2,  chave: 'id_pro_insumo_codigo',  nome: 'Cód.',             fieldsApi: { id: null } },
          { mPer: 2,  chave: 'id_pro_insumo_nome',    nome: 'Nome',             fieldsApi: { id_pro_insumo: { j: { codigo: null, nome: null, id_uni: null } } } },
          { mPer: 2,  chave: 'id_pro_insumo_id_uni',  nome: 'Unidade',          fieldsApi: {} },
          { mPer: 2,  chave: 'qtde',                  nome: 'Quantidade',       fieldsApi: { qtde: null } },
          { mPer: 2,  chave: 'last',                  nome: 'Última Alteração', fieldsApi: { last_at: null, last_user: { j: { usuario: null } } } }
        ]

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.proFormInsumoReiniciar()
        } else {
          this.proFormInsumoSetarStatusGeral('')
        }
      },
      proFormInsumoAbrirCadastro: function (tipo, id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: tipo, id: id }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.proFormInsumoBuscarLinhas()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      proFormInsumoTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { aOr: [
              { o: 's.ft', v: where.v }
            ] }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false

            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      proFormInsumoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormInsumoReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proFormInsumoReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proFormInsumoSetarLinhas: function (vetor) {
        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // A QUANTIDADE DE LINHAS
        this.$emit('SETAR_QTDE_INSUMO', this.linha.length)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // ATUALIZA O VALOR QUE SERÁ ENVIADO
        this.proFormInsumoAtualizarValor(true)
      },
      proFormInsumoMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormInsumoExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) insumos(s) selecionado(s)?')) {
          // REMOVE AS LINHAS SOLICITADAS
          this.linha = this.linha.filter(item => this.checkbox.indexOf(item.id) === -1)

          // A QUANTIDADE DE LINHAS
          this.$emit('SETAR_QTDE_INSUMO', this.linha.length)

          // LIMPA OS CHECKBOX DA TABLEA
          this.checkbox = []

          // MANDA ATUALIZAR O FORMLARIO QUE SERÁ SALVO NA API
          this.proFormInsumoOnAtualizarFormulario()

          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.msgWarn('WEB [406]: Os insumos excluídos, serão removidos ao clicar no botão inserir ou atualizar para salvar o cadastro do produto.', 'warning')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR SERÁ ATUALIZADO
          this.proFormInsumoAtualizarValor()
        }
      },
      proFormInsumoOnChangeValue: function (indexL, indexF, value) {
        // SETA O NOVO VALOR DO CAMPO
        this.linha[indexL][indexF] = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR SERÁ ATUALIZADO
        this.proFormInsumoAtualizarValor()
      },
      proFormInsumoOnFecharFormulario: function () {
        // VERIFICA SE DEVE ABRIR O FORMULARIO
        this.formulario = !this.formulario

        // LIMPA OS CAMPOS PREENCHIDOS
        this.campos.produto.onRealizaBusca()

        // SETA O FOCUS NO CAMPO
        this.proFormInsumoRealizarFocusCampo('produto')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proFormInsumoOnNovoProduto: function (nome) {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'produto', id: 0, nome: nome }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.proFormInsumoOnChangeValueForm('produto', dados)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      proFormInsumoOnChangeValueForm: function (indexF, value) {
        // SETA O VALOR RECEBIDO NO CAMPO
        this.campos[indexF].value = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE TEM QUE PERSONALIZAR ALGUMA COISA
        switch (indexF) {
          case 'produto':
            // SETA O CAMPO QUANTIDADE
            this.campos.qtde.value = '1.00'

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // VERIFICA SE DEVE INSERIR OU NÃO O VALOR
            if (value.__INSERT_VALUE__ === true) {
              this.proFormInsumoInserirProduto()
            } else {
              setTimeout(() => { this.proFormInsumoRealizarFocusCampo('qtde') }, 100) 
            }
            break
        }
      },
      proFormInsumoInserirProduto: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // INICIA A VARIAVEL DE VERIFICAÇÃO
        var passou = false

        // FAZ AS VALIDAÇÕES DOS CAMPOS
        if ([ '', null, undefined ].indexOf(this.campos.produto.value) !== -1) {
          this.$store.state.msgWarn('WEB [400]: É necessário selecionar um produto válido para continuar.', 'warning')
        } else if ([ '', null, undefined ].indexOf(this.campos.qtde.value) !== -1) {
          this.$store.state.msgWarn('WEB [400]: É necessário informar uma qtde válida para continuar.', 'warning')
        } else if (this.campos.produto.value.id.toString() === this.cpntId.toString()) {
          this.$store.state.msgWarn('WEB [400]: Não é possível inserir o próprio produto como insumo dele mesmo.', 'warning')
        } else {
          passou = true
        }

        // VERIFICA SE PASSOU NAS VERIFICAÇÕES
        if (passou === true) {
          // PEGA A VARIAVEL RECEBIDA
          var produto = JSON.parse(JSON.stringify(this.campos.produto.value))

          // INICIA O FORMULARIO QUE SERÁ INSERIDO NA TABLEA
          var formData = {}
          
          // RODA UM FETOR INSERIDO O PRODUTO
          for (var indexF in produto) {
            formData['id_pro_insumo_' + indexF] = produto[indexF]
          }

          // SETA O VALOR DO ID DO PRODUTO
          formData.id_pro_insumo = produto.id

          // SETA O ID OD CAMPO
          formData.id = '__NOVO_ITEM__' + new Date().getTime()

          // SETA A QUANTIDADE INSERIDA NO CAMPO
          formData.qtde = this.campos.qtde.value
          
          // ADICIONA O PRODUTO A TABELA
          this.linha.push(formData)

          // A QUANTIDADE DE LINHAS
          this.$emit('SETAR_QTDE_INSUMO', this.linha.length)

          // FECHA O FORMULARIO DO PRODUTO
          this.proFormInsumoOnFecharFormulario()

          // MANDA ATUALIZAR O FORMLARIO QUE SERÁ SALVO NA API
          this.proFormInsumoOnAtualizarFormulario()

          // CHAMA A FUNÇÃO PARA ATUALIZAR O VALOR SERÁ ATUALIZADO
          this.proFormInsumoAtualizarValor()
        }
      },
      proFormInsumoOnAtualizarFormulario: function () {
        // INICIA O VETOR QUE SERÁ ATUALIZADO
        var formData = []

        // RODA UM VETOR PROCURANDO OS VALORES A SEREM INSERIDOS
        for (var indexL in this.linha) {
          if (this.linha[indexL].id.indexOf('__NOVO_ITEM__') !== -1) {
            formData.push({ id_pro_insumo: this.linha[indexL].id_pro_insumo_id, qtde: this.linha[indexL].qtde })
          }
        }

        // VERIFICA SE DEVE SETAR O NOVO VALOR NO CAMPO
        this.formData = formData.length >= 1 ? JSON.stringify(formData) : null
      },
      proFormInsumoRealizarFocusCampo: function (chave, tentativa = 0) {
        if (this.$store.state.mobile === false && tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
            this.$refs[chave].cpntRealizarFocus()
          } else {
            setTimeout(() => { this.proFormInsumoRealizarFocusCampo(chave, (tentativa + 1)) }, 100)
          }
        }
      },
      proFormInsumoAtualizarValor: function (valueIni = false) {
        // INICIA O FORMULARIO QUE SERÁ ENVIADO
        var formData = []

        // RODA UM FOR INSERIDO OS PRODUTOS
        for (var indexL in this.linha) {

          var qtdeFormat = this.linha[indexL].qtde

          // REMOVE OS PONTOS DA STRING
          while (qtdeFormat.indexOf('.') > -1) {
            qtdeFormat = qtdeFormat.replace('.', '')
          }

          // CONVERTE O NUMERO EM VALOR 
          qtdeFormat = Number(qtdeFormat.replace(',', '.')).toString()

          formData.push({ id_pro_insumo: this.linha[indexL].id_pro_insumo, qtde: qtdeFormat })
        }

        // SETA O VALOR RECEBIDO NO CAMPO
        this.campos.j_insumo.value = JSON.stringify(formData)

        // SETA O VALOR INICIAL DO CAMPO
        if (valueIni === true) {
          this.campos.j_insumo.valueIni = this.campos.j_insumo.value + ' '
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
